export default {
  error: {},
  info: {},
  success: {},
  isAPIProgress: false,
  jobCities: [],
  homeCities: [],
  searchedCities: [],
  localities: [],
};
